import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function Comparison() {
  const comparisons = [{
    without: 'Armás informes desde cero',
    with: 'Informes con plantilla lista, solo completás'
  }, {
    without: 'Reuniones sin estructura',
    with: 'Guía de reunión paso a paso con acta incluida'
  }, {
    without: 'Comunicación informal con familias',
    with: 'Modelos profesionales de comunicación'
  }, {
    without: 'Sin protocolos institucionales',
    with: 'Protocolos listos para presentar a dirección'
  }, {
    without: 'Gestión desorganizada',
    with: 'Sistema de organización institucional completo'
  }];
  return <section className="w-full py-16 bg-[#111111] pt-[0px] pb-[0px]" data-id="element-55">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-56">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-57">
          ¿Qué cambia con el{' '}
          <span className="tracking-wide font-[700] font-['Open_Sans',_sans-serif] text-[#CAB072]" data-id="element-58">
            KIT PROFESIONAL COMPLETO
          </span>
          ?
        </h2>
        <div className="bg-[#1A1A1A] rounded-lg border border-[#2A2A2A] overflow-hidden" data-id="element-59">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-60">
            <div className="p-6 border-b md:border-b-0 md:border-r border-[#2A2A2A]" data-id="element-61">
              <h3 className="text-xl font-bold text-red-500 mb-6 flex items-center gap-2" data-id="element-62">
                <XIcon className="w-6 h-6" data-id="element-63" /> SIN el Kit PRO
              </h3>
              <div className="space-y-4" data-id="element-64">
                {comparisons.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-65">
                    <XIcon className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-66" />
                    <p className="text-gray-400" data-id="element-67">{item.without}</p>
                  </div>)}
              </div>
            </div>
            <div className="bg-[#D4A843]/5 p-6" data-id="element-68">
              <h3 className="text-xl font-bold text-[#D4A843] mb-6 flex items-center gap-2" data-id="element-69">
                <CheckIcon className="w-6 h-6" data-id="element-70" /> CON el Kit PRO
              </h3>
              <div className="space-y-4" data-id="element-71">
                {comparisons.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-72">
                    <CheckIcon className="w-5 h-5 text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-73" />
                    <p className="text-gray-200 font-medium" data-id="element-74">{item.with}</p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}